import { cva } from 'class-variance-authority'
import { LoyaltyBackgroundTint } from '../schemas/LoyaltyTint'

export const cardBackgroundCva = cva('', {
  variants: {
    tint: LoyaltyBackgroundTint,
  },
  defaultVariants: {
    tint: 'primary',
  },
})
